import { SHOW_SPINNER } from "../auth/constants";

const initialState = {
  showSpinner: false,
};

/**
 * Reducer function to manage the spinner state in the Redux store.
 * It handles actions related to showing or hiding the spinner.
 *
 * @param {Object} state - The current state of the spinner.
 * @param {Object} action - The action dispatched to the reducer.
 * @return {Object} The new state of the spinner after applying the action.
 **/
export default function spinner(state = initialState, action) {
  switch (action.type) {
    case SHOW_SPINNER: {
      return {
        ...state,
        showSpinner: action.showSpinner,
      };
    }
    default:
      return state;
  }
}
